import { ProductPageProps } from "@omni/types/components/props/productPage.props";
import { RequireChildrenFor } from "@omni/types/components/utils/children.types";

import { useProductPageImpressionTracking } from "@/components/ProductPage/hooks/useProductPageImpressionTracking.hook";

import { ProductPageContextProvider } from "./context/productPage.context";

export const Base = ({
    product,
    brandPagePath,
    contextAwareXfPath,
    features,
    eCommerce,
    infoCards,
    recommendSlider,
    usps,
    reviews,
    promoBanner,
    sliders,
    children
}: RequireChildrenFor<ProductPageProps>) => {
    const { ref } = useProductPageImpressionTracking({
        product: product,
        reviews: reviews
    });

    return (
        <div ref={ref}>
            <ProductPageContextProvider
                product={product}
                brandPagePath={brandPagePath}
                contextAwareXfPath={contextAwareXfPath}
                maxVisibleFeatures={features.maxVisibleFeatures}
                cashbackPagePath={eCommerce.cashbackPagePath}
                paintConfiguratorPath={eCommerce.paintConfiguratorPath}
                infoLink={eCommerce.infoLink}
                tooltips={eCommerce.tooltips}
                totalReviews={reviews?.totalReviews}
                reviews={reviews?.reviews}
                reviewsSummary={reviews?.reviewsSummary}
                promoBannerHTML={promoBanner?.promoBannerHTML}
                infoCards={infoCards}
                sliders={sliders}
                algoliaRecommendParams={recommendSlider.algoliaRecommendParams}
                usps={usps}
            >
                {children}
            </ProductPageContextProvider>
        </div>
    );
};
